import React, { FC } from 'react';
import { MainLayoutProps } from '../../layouts/MainLayout';
import Hero, { HeroProps } from '../../components/molecules/Hero';
import CardsBlock, { CardsBlockProps } from '../../components/molecules/CardsBlock';
import TwoColumnsLayout from '../../layouts/TwoColumnsLayout';
import { TagsCloudProps } from '../../components/molecules/TagsCloud';
import { ActionButtonProps } from '../../components/atoms/ActionButton';
import { HtmlProps } from '../../components/atoms/Html';
import ShareButton, { ShareButtonProps } from '../../components/atoms/ShareButton';
import * as SC from './styled';
export type ArticleTemplateProps = MainLayoutProps & {
  heroProps?: HeroProps;
  sideContent?: React.ReactNode;
  articlesProps?: CardsBlockProps;
  tagsCloudProps?: TagsCloudProps;
  intro?: HtmlProps;
  actions?: (ActionButtonProps | ShareButtonProps)[];
  topContent?: React.ReactNode;
};
const ArticleTemplate: FC<ArticleTemplateProps> = ({
  heroProps,
  sideContent,
  intro,
  actions,
  articlesProps,
  tagsCloudProps,
  children,
  topContent,
  ...layoutProps
}) => {
  return <SC.Layout {...layoutProps}>
      {heroProps && <Hero htmlTag="header" htmlTitleTag="h1" {...heroProps} />}
      <TwoColumnsLayout mainContent={<>
            {topContent}
            <SC.Main>
              <SC.Section>
                {intro && <SC.IntroText {...intro} />}
                {actions && <SC.Actions>
                    {actions.map((action, i) => {
              return 'sharingActions' in action ? <ShareButton {...action} key={i} /> : <SC.Button key={i} {...action} />;
            })}
                  </SC.Actions>}
              </SC.Section>
              {children}
            </SC.Main>
          </>} sideContent={sideContent} />
      {articlesProps && <CardsBlock {...articlesProps} />}
      {tagsCloudProps && <SC.TagCloud {...tagsCloudProps} />}
    </SC.Layout>;
};
export default ArticleTemplate;